import { EditorLoader } from "./editor/editor_loader.js";

import "./ejson/ejson.parser.js";
import "./editor/ace.editor.js";

(function () {
  EditorLoader.init();
}).call(this);
